export enum Sizes {
  large = 'LARGE',
  medium = 'MEDIUM',
  small = 'SMALL',
}
